module.exports = __webpack_public_path__ + "img/alien-bug.e74a737c.svg";